import { CustodyCustomerV4Entity } from '@genial/services';
import { atom } from 'recoil';

import { pagination } from './constants';
import {
  CustomerBlockReasonModal,
  CustomerBySearchTermParams,
  CustomerItem,
  CustomerParams,
  CustomerStatus,
} from './types';

export const customerStatusState = atom<CustomerStatus>({
  key: 'customerStatusState',
  default: {
    label: 'Selecione o cliente',
    status: 'opened',
  },
});

export const customerItemState = atom({
  key: 'customerItemState',
  default: {
    current: {},
    previous: {},
  } as CustomerItem,
});

export const customerParamsState = atom({
  key: 'customerParamsState',
  default: {
    ...pagination,
  } as CustomerParams,
});

export const customerBySearchTermParamsState = atom({
  key: 'customerBySearchTermParamsState',
  default: {
    ...pagination,
    skipEndpointCall: true,
  } as CustomerBySearchTermParams,
});

export const listAllCustomersState = atom({
  key: 'listAllCustomersState',
  default: [] as CustodyCustomerV4Entity[],
});

export const listCustomersBySearchTermState = atom({
  key: 'listCustomersBySearchTermState',
  default: [] as CustodyCustomerV4Entity[],
});

export const isExportingPdfForCustomers = atom({
  key: 'isExportingPdfForCustomers',
  default: false,
});

export const blockReasonModalState = atom<{
  isOpen: boolean;
  customer?: CustomerBlockReasonModal;
}>({
  key: 'blockReasonModalState',
  default: {
    isOpen: false,
    customer: undefined,
  },
});
